import React from 'react'
import { useQuery } from 'react-query'

import { PurcsPreview, PreviewModes } from '@vp/react-product-preview'
import { useLocalizations } from '@vp/ubik-localizations-provider'
import { useLogger, useTenantMappings } from '@vp/ubik-context'

import { getPreviewInstructions } from '../../clients/PreviewInstructionsClient'
import type { PreviewInstructions } from '../../types/PreviewInstructions'
import { useProject } from '../root/contexts/ProjectContext'
import { useAppState } from '../root/contexts/AppContext'
import { PURCS_ORIGIN_URL, REQUESTOR } from '../../utils/constants'

const PurcsProductPreview: React.FC = () => {
  const { work, productKey, productVersion, productName } = useProject()
  const { t } = useLocalizations()
  const { culture } = useAppState()
  const { previewAssets } = useTenantMappings()
  const logger = useLogger()

  const { data: previewMode } = useQuery(
    ['preview-instructions-preview-mode', work.design.displayUrl],
    async () => {
      let previewInstructions = {} as PreviewInstructions
      try {
        previewInstructions = await getPreviewInstructions(work.design.displayUrl, logger)
      } catch {
        // Fall back to single image if we can't fetch preview instructions
        return PreviewModes.FirstPageOnly
      }

      return previewInstructions?.Slots?.length > 1 ? PreviewModes.Carousel : PreviewModes.FirstPageOnly
    },
    {
      staleTime: Infinity,
      enabled: !!work,
    },
  )

  return (
    <>
      {work.workId && previewMode && (
        <PurcsPreview
          tenantId={previewAssets}
          requestor={REQUESTOR}
          coreProductKey={productKey}
          productVersion={productVersion}
          optionSelections={work.merchandising.merchandisingSelections}
          previewInstructionsUri={work.design.displayUrl}
          previewMode={previewMode}
          locale={culture}
          purcsOrigin={PURCS_ORIGIN_URL}
          accessibleTextForNext={t('product-preview.next-button-alt-text')}
          accessibleTextForPrevious={t('product-preview.previous-button-alt-text')}
          width={1000} // default value
          productName={productName}
        />
      )}
    </>
  )
}

export default PurcsProductPreview
